import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Formik} from "formik";
import {useAuth} from "../../../contexts/authContext";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

// React Components
import Input from "../../../components/Input";
import ErrorMessage from "../../../components/ErrorMessage";

// CSS Files
import "./styles.css";

const LoginForm = (props) => {
   const auth = useAuth();
   const history = useHistory();
   const { t } = useTranslation();

   return <div className={"LoginForm"}>
      <Row>
         <Col xs={10} sm={9} md={7} lg={5} className={"mx-auto"}>
            <Formik
               initialValues={{email: '', password: ''}}
               validationSchema={Yup.object({
                  email: Yup.string()
                  .required(t('common.form.errors.mandatory_field'))
                  .email(t('common.form.errors.invalid_email')),
                  password: Yup.string()
                  .required(t('common.form.errors.mandatory_field'))
               })}
               onSubmit={(values) => {
                  auth.login(values.email, values.password, () => {
                     history.push(history.location.state?.from || '/');
                  })
               }}
            >
               {formik => (
                  <form onSubmit={formik.handleSubmit}>
                     <Input
                        id={"email"}
                        name={"email"}
                        inputType="email"
                        placeHolder={t('common.form.labels.email')}
                        inputTextValue={formik.values.email}
                        handleChange={formik.handleChange}
                        handleOnBlur={formik.handleBlur}
                        classNames={"pb-4"}
                     />
                     <ErrorMessage errors={formik.errors} touched={formik.touched} name={"email"}/>

                     <Input
                        id={"password"}
                        name={"password"}
                        inputType="password"
                        placeHolder={t('common.form.labels.password')}
                        inputTextValue={formik.values.password}
                        handleChange={formik.handleChange}
                        handleOnBlur={formik.handleBlur}
                     />
                     <ErrorMessage errors={formik.errors} touched={formik.touched} name={"password"}/>

                     <Button className={"w-100 mt-1 mb-3 login-button"} type="submit" variant={"primary"}>{t('login_page.log_in')}</Button>
                  </form>
               )}
            </Formik>
         </Col>
      </Row>

      <Row>
         <Col xs={12} className={"text-center mb-2"}>
            <p className={"links"} onClick={() => props.setPage("passwordRecovery")}>{t('login_page.forgotten_password')}</p>
         </Col>
         <Col xs={12} className={"text-center"}>
            <p className={"links"} onClick={() => props.setPage("registration")}>{t('login_page.unregistered')}</p>
         </Col>
      </Row>
   </div>
};

export default LoginForm;